import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectItemMessageFormDataArchives = createSelector(
  [
    (store: RootState) =>
      store.paymentNoticeDetail.itemMessageFormData.archives,
  ],
  (archives) => archives
);
